import ArrowUp from '../../src/legacy/ArrowUp';
export default ArrowUp;
